<script lang="ts">
import { Container } from 'inversify'
import { computed, defineComponent } from 'vue'

import { StatusType } from '@collector/sportsapi-client-legacy'
import EventHeader from '@mobile/views/Relation/Shared/EventHeader/EventHeader.vue'
import Popup from '@mobile/views/Relation/Shared/Popup/Popup.vue'
import { bindSeasonParticipants } from '@mobile/views/Relation/Shared/RelationDependencies/bindSeasonParticipants'
import { bindSkins } from '@mobile/views/Relation/Shared/RelationDependencies/bindSkins'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import VerifyResults from '@mobile/views/Relation/Shared/VerifyResults/VerifyResults.vue'
import { BasketballRelationIoCBindings } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/BasketballRelationDependencies'
import { bindAssignableIncidentConfiguration } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindAssignableIncidentConfiguration'
import { bindEventHeaderConfiguration } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindEventHeaderConfiguration'
import { bindEventStatusesConfiguration } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindEventStatusesConfiguration'
import { bindEventStatusesList } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindEventStatusesList'
import { bindIncidentHandlersConfiguration } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindIncidentHandlersConfiguration'
import { bindIncidentsConfiguration } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindIncidentsConfiguration'
import { bindIncidentsResultConfiguration } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindIncidentsResultConfiguration'
import { bindLineupsConfiguration } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindLineupsConfiguration'
import { bindRelationHooks } from '@mobile/views/Relation/Sports/Basketball/BasketballRelationDependencies/bindRelationHooks'
import LiveView from '@mobile/views/Relation/Sports/Basketball/LiveView/LiveView.vue'

import { bindEventClockConfiguration } from '../Basketball/BasketballRelationDependencies/bindEventClockConfigration'
import { bindActiveParticipant } from './BasketballRelationDependencies/bindActiveParticipant'

export default defineComponent({
  components: {
    VerifyResults,
    LiveView,
    Popup,
    EventHeader,
  },
  setup() {
    const { probableEvent } = useEventInjections()

    const displayVerifyResults = computed(() => {
      const probableRelationStatus = probableEvent.value?.status_type

      return probableRelationStatus === StatusType.Finished
    })

    return { displayVerifyResults }
  },
})

export function bindBasketballRelationDependencies(
  ioc: Container,
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
): Record<any, any> {
  bindEventStatusesConfiguration(ioc)
  bindIncidentHandlersConfiguration(ioc)
  bindEventStatusesList(ioc)
  bindIncidentsConfiguration(ioc)
  bindIncidentsResultConfiguration(ioc)
  bindSeasonParticipants(ioc)
  bindLineupsConfiguration(ioc)
  bindAssignableIncidentConfiguration(ioc)
  bindRelationHooks(ioc)
  bindEventHeaderConfiguration(ioc)
  bindActiveParticipant(ioc)
  bindEventClockConfiguration(ioc)

  bindSkins(ioc)

  return BasketballRelationIoCBindings
}
</script>

<template>
  <Popup />
  <EventHeader />
  <VerifyResults v-if="displayVerifyResults" />
  <LiveView v-else />
</template>
